module.exports = __webpack_public_path__ + "media/images/shared/side_menus/icons/profile-fb68fc88ca75e5624d6dbcba4ff3902c.png";